import { Component, ElementRef, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CellDoubleClickedEvent, GridOptions, GridReadyEvent, SelectionChangedEvent } from 'ag-grid';
import { constant } from 'app/app.constants';
import { AgGridSortFilterUtils } from 'app/core/ag-grid-utils/ag-grid-sort-filter-utils';
import { AgButtonsEnum, DepositAction, DepositActions, DepositGridName, OptionImportEnum } from 'app/core/enums/tabs-deposits.enum';
import { FormatCurrencyHelper } from 'app/core/helpers/format-currency-helper';
import { CustomDate } from 'app/core/helpers/format-date-helper';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { IDeposit, ILockBox } from 'app/core/interfaces/deposit.interface';
import { ConciliationService } from 'app/core/services/conciliation.service';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { UploadsService } from 'app/pages/A2-utils/uploads.service';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { getSelectNodeAfterFilter } from 'app/utils/helpers';
import { Observable, Subscription } from 'rxjs';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { getCellStylesByStatus } from '../helper';

@Component({
  selector: 'app-office-deposit',
  templateUrl: './office-deposit.component.html',
  styleUrls: ['./office-deposit.component.scss']
})
export class OfficeDepositComponent extends ParentModule implements OnInit, OnDestroy {
  @ViewChild('modalImportLockBox') modalImportLockBox: T2CardComponent;
  @ViewChild('fileLockBox') fileLockBox: ElementRef;
  @ViewChild('modalOfficeDepositSelected') modalOfficeDepositSelected: T2CardComponent;
  gridLockBoxOptions: GridOptions;
  subscriptions: Subscription[] = [];
  lockBoxCrudForm: FormGroup;
  lockBoxSearch: FormGroup;
  officeDeposiModalGroup: FormGroup;
  reqSearhc: IDeposit = { depositdate: null };
  totalRows = 0;
  optionImportLockBox = OptionImportEnum.LockBox;
  agGridButtonActionList = {
    RemoveFilter: AgButtonsEnum.RemoveFilter,
    RemoveSort: AgButtonsEnum.RemoveSort
  };
  depositActionList = {
    Save: DepositAction.Save,
    Update: DepositAction.Update
  };
  enableClearFilter = true;
  enableClearSort = true;
  totalAmount = 0;
  totalLockBoxAmountSelected = 0;
  selectedRowIndex = null;
  public actionsDeposit = [];
  officeModalTitle = '';
  buttonModalText = 'Save';
  saveOffice = true;
  officeDepositRowSelected = [];
  textModalCrud = 'New Office Deposit';
  textBtnModalOfficeDepositCrud = 'Save';
  noBlankSpace = constant.NO_BLANK_SPACE;
  rowIdGrouped = [];
  diffBetweenDepositAmtAndAmtPaid = null;
  displayedGroupCount = 0;
  depositOfficeDescriptionList = [];
  depositOfficeDescriptionSelected = null;

  get officeDeposiFormtArrayCtrl (): FormArray {
    return this.officeDeposiModalGroup.get('officedeposiformtarray') as FormArray;
  }

  get sequenceVal(): number {
    return this.lockBoxCrudForm.get('sequence').value;
  }

  get officeDepositIdCtrl (): AbstractControl {
    return this.lockBoxCrudForm.get('officedepositid');
  }

  get amountpaidVal(): number {
    return this.lockBoxCrudForm.get('amountpaid').value;
  }

  get depositMonthLckBoxCtrl(): AbstractControl {
    return this.lockBoxSearch.get('depositdatelockbox');
  }

  get filesNamesCtrl(): AbstractControl {
    return this.lockBoxSearch.get('file');
  }

  get uploadfilesCtrl(): AbstractControl {
    return this.lockBoxSearch.get('uploadfiles');
  }

  get showFileInputLockBox(): string {
    return '.xls, .xlsx, .csv';
  }

  get validButtonSaveModalOffDep (): boolean {
    const location = this.getCtrlOffiDepModal('scanneddoc').valid;
    const receivedin = this.getCtrlOffiDepModal('receivedin').valid;
    const deposit = this.getCtrlOffiDepModal('deposit').valid;
    const formArrayStatus = this.officeDeposiFormtArrayCtrl.valid;
    return !location || !receivedin || !deposit || !formArrayStatus;
  }

  get hasBalance(): boolean {
    return this.diffBetweenDepositAmtAndAmtPaid === 0;
  }

  get displayedRowCount(): number {
    if (this.gridLockBoxOptions && this.gridLockBoxOptions.api) {
      return this.gridLockBoxOptions.api.getDisplayedRowCount() - this.displayedGroupCount;
    } else {
      return 0;
    }
  }

  getDetailRowStyle (horizontalAligned: 'center' | 'end' | 'start' = 'start'): any {
    const borderStyle = '1px dotted #1464f64d';
    const borderStyleNone = 'none';
    const response = {
      display: 'flex',
      'align-items': 'center',
      'justify-content': horizontalAligned,
      'border-top': borderStyleNone,
      'border-bottom': borderStyle
    };
    return response;
  }

  getRowStyle(params: any, horizontalAligned: 'center' | 'flex-end' | 'flex-start' = 'flex-start'): any {
    const borderStyle = '1px dotted #1464f64d';
    const borderStyleNone = 'none';
    const response = {
      'background-color': '#ffffff',
      'color': '#000000',
      display: 'flex',
      'align-items': 'center',
      'justify-content': horizontalAligned,
      'border-top': borderStyle,
      'border-bottom': borderStyle,
      'text-align': 'center'
    };

    if (params && params.data && params.data.rowSpan !== undefined) {
      response['border-top'] = borderStyleNone;
    }
    return response;
  }

  constructor(
    private fb: FormBuilder,
    private t2LoadingService: T2LoadingService,
    private sweetAlertHelper: SweetAlertHelper,
    protected objServ: ConciliationService,
    private objToast: ToastrAlertHelper,
    private uploadsService: UploadsService,
    protected inject: Injector
  ) {
    super('app-deposits', inject);
    this.createForm();
    this.gridBuilder();
  }

  ngOnInit(): void {
    this.initSubscriptions();
    this.getDepositbyCurrentMonth();
  }

  getDepositbyCurrentMonth(): void {
    this.lockBoxSearch.get('depositdatelockbox')
    .patchValue(CustomDate.formatJsV2(CustomDate.getDate()), { emitEvent: false });
  }

  createForm(): void {
    this.lockBoxSearch = this.fb.group({
      depositdatelockbox: ['', Validators.required],
      file: '',
      uploadfiles: ''
    });
    this.lockBoxCrudForm = this.fb.group({
      officedepositid: null,
      checkdate: [null, Validators.required],
      checkaccount: null,
      sequence: null,
      serialnumber: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      amountpaid: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      payor: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      posted: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      note: '',
      statusid: [null, Validators.required],
      statusdescription: [null, Validators.required],
      reviewedby: null,
      reviewedfullname: null,
      trandate: [null, Validators.required],
      location: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]]
    });
    this.officeDeposiModalGroup = this.fb.group({
      receivedin: [null, Validators.required],
      scanneddoc: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      deposit: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      officedeposiformtarray: this.fb.array([])
    });
  }

  gridBuilder(): void {
    this.gridLockBoxOptions = <GridOptions> {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      suppressRowClickSelection: true,
      suppressRowTransform: true,
      rowSelection: 'single',
      getRowStyle: () => {
        const borderStyleNone = 'none';
        return { 'border-bottom': borderStyleNone, 'border-top': borderStyleNone };
      },
      columnDefs: [
        {
          headerName: 'Group Key',
          field: 'groupkey',
          width: 190,
          hide: true,
          rowSpan: (params) => {
            return params.data.rowSpan !== undefined ? params.data.rowSpan : 0;
          },
          cellStyle: (param) => this.getRowStyle(param)
        },
        {
          headerName: 'Received In',
          field: 'trandate',
          width: 110,
          valueGetter: (params) => {
            if (params && params.data.trandate) {
              return CustomDate.formatJs(params.data.trandate);
            }
          },
          rowSpan: (params) => {
            return params.data.rowSpan !== undefined ? params.data.rowSpan : 0;
          },
          cellStyle: (param) => this.getRowStyle(param, 'center')
        },
        {
          headerName: 'Scanned Document',
          field: 'location',
          width: 140,
          rowSpan: (params) => {
            return params.data.rowSpan !== undefined ? params.data.rowSpan : 0;
          },
          cellStyle: (param) => this.getRowStyle(param)
        },
        {
          headerName: 'Deposit',
          field: 'deposit',
          width: 120,
          cellRenderer: (params) => {
            const decimal = 0;
            return params && params.data.deposit
            ? '$' + params.data.deposit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : '$' + decimal.toFixed(2);
          },
          filterParams: AgGridSortFilterUtils.sortFilterColumn,
          rowSpan: (params) => {
            return params.data.rowSpan !== undefined ? params.data.rowSpan : 0;
          },
          cellStyle: (param) => this.getRowStyle(param, 'flex-end')
        },
        {
          headerName: 'Deposit ID',
          field: 'depositid',
          width: 100,
          filterParams: AgGridSortFilterUtils.sortFilterColumn,
          rowSpan: (params) => {
            return params.data.rowSpan !== undefined ? params.data.rowSpan : 0;
          },
          cellStyle: (param) => this.getRowStyle(param, 'flex-end')
        },
        {
          headerName: 'Sequence',
          field: 'officedepositid',
          width: 60,
          cellStyle: this.getDetailRowStyle('end'),
          suppressFilter: true,
          suppressSorting: true
        },
        {
          headerName: 'Check Date',
          field: 'checkdate',
          width: 110,
          valueGetter: (params) => {
            if (params && params.data && params.data.checkdate) {
              return CustomDate.formatJs(params.data.checkdate);
            }
          },
          cellStyle: this.getDetailRowStyle('center'),
          suppressFilter: true,
          suppressSorting: true
        },
        {
          headerName: 'Check Number',
          field: 'serialnumber',
          width: 130,
          cellStyle: this.getDetailRowStyle,
          suppressFilter: true,
          suppressSorting: true
        },
        {
          headerName: 'Amount Paid',
          field: 'amountpaid',
          width: 100,
          valueGetter: (params) => {
            if (params && params.data && params.data.amountpaid) {
              const decimal = 0;
              return params && params.data.amountpaid
              ? '$' + params.data.amountpaid.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              : '$' + decimal.toFixed(2);
            }
          },
          filterParams: AgGridSortFilterUtils.sortFilterColumn,
          cellStyle: this.getDetailRowStyle('end'),
          suppressFilter: true,
          suppressSorting: true
        },
        {
          headerName: 'Posted',
          field: 'posted',
          width: 120,
          valueGetter: (params) => {
            if (params && params.data && params.data.posted) {
              const decimal = 0;
              return params && params.data.posted
              ? '$' + params.data.posted.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              : '$' + decimal.toFixed(2);
            }
          },
          filterParams: AgGridSortFilterUtils.sortFilterColumn,
          cellStyle: this.getDetailRowStyle('end'),
          suppressFilter: true,
          suppressSorting: true
        },
        {
          headerName: 'Payor',
          field: 'payor',
          cellStyle: this.getDetailRowStyle(),
          suppressFilter: true,
          suppressSorting: true
        },
        {
          headerName: 'StatusId',
          field: 'statusid',
          width: 120,
          hide: true,
          suppressFilter: true,
          suppressSorting: true
        },
        {
          headerName: 'Deposit Status',
          field: 'depositstatusdescription',
          width: 120,
          cellStyle: (params) => getCellStylesByStatus().stylesByDeposit(params.data.depositstatusid),
          suppressFilter: true,
          suppressSorting: true
        },
        {
          headerName: 'Posted Status',
          field: 'postedstatusdescription',
          width: 120,
          cellStyle: (params) => getCellStylesByStatus().stylesByPosted(params.data.postedstatusid),
          suppressFilter: true,
          suppressSorting: true
        },
        {
          headerName: 'Posted Ids',
          field: 'postedids',
          cellStyle: this.getDetailRowStyle(),
          width: 100,
        },
        {
          headerName: 'Reviewed by ID',
          field: 'reviewedby',
          hide: true,
          width: 120,
          cellStyle: this.getDetailRowStyle(),
          suppressFilter: true,
          suppressSorting: true
        },
        {
          headerName: 'Reviewed by',
          field: 'reviewedfullname',
          width: 120,
          cellStyle: this.getDetailRowStyle(),
          suppressFilter: true,
          suppressSorting: true
        },
        {
          headerName: 'Note',
          field: 'note',
          width: 120,
          cellStyle: this.getDetailRowStyle(),
          suppressFilter: true,
          suppressSorting: true
        }
      ],
      onGridReady: (event: GridReadyEvent) => {
        if (event && this.gridLockBoxOptions && this.gridLockBoxOptions.api) {
          this.gridLockBoxOptions.api.setRowData([]);
          this.gridLockBoxOptions.api.sizeColumnsToFit();
        }
      },
      onRowClicked: (params) => {
        if (params && params.data && params.data.officedepositid) {
          this.selectedRowIndex = params.data.officedepositid;
          this.removeStyleRowGrid();
          this.gridLockBoxOptions.api.redrawRows();
        }
      },
      onCellDoubleClicked: (params: CellDoubleClickedEvent) => {
        if (params && params.data && params.data.officedepositid) {
          this.textModalCrud = 'Update Office Deposit';
          this.searchOfficeDepositGrouped(params.data);

          if (params.data.trandate) {
            this.getOfficeDepositDescriptionList(params.data.trandate);
          }

          if (params.data.depositid) {
            this.depositOfficeDescriptionSelected = params.data.depositid;
          } else {
            this.depositOfficeDescriptionSelected = null;
          }
        }

        if (params && params.api) {
          params.api.clearFocusedCell();
        }
      },
      onFilterChanged: () => {
        this.selectedRowIndex = null;
        this.rowIdGrouped = [];
        this.updateButtonState();
        if (this.gridLockBoxOptions && this.gridLockBoxOptions.api) {
          this.gridLockBoxOptions.api.redrawRows();
        }
        this.getGroupCount();
      },
      onSortChanged: () => {
        this.updateButtonState();
      },
      rowClassRules: {
        'row-default-deposit-grid': (params) => {
          return params && params.data && params.data.officedepositid !== null;
        },
        'row-selected-deposit': (params) => {
          return params && params.data && this.rowIdGrouped.includes(params.data.officedepositid);
        }
      },
      getRowNodeId: (data) => data.officedepositid
    };
  }

  initSubscriptions(): void {
    this.subscriptions.push(
      this.objServ.behaviorSubjDepositObs$.subscribe({
        next: (res) => {
          if (res && res.action === DepositAction.SearchOfficeDeposit && res.data) {
            const dateMonthLockBox = this.depositMonthLckBoxCtrl.value;
            const req: IDeposit = { depositdate: CustomDate.formatJs(dateMonthLockBox, 'MM-yyyy') };
            this.searchOfficeDeposit(req);
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      }),
      this.objServ.behaviorSubjDeposit.subscribe({
        next: (res) => {
          if (res && res.data &&
            (
              res.action === DepositAction.MonthPickerSetterValueChangesDeposit ||
              res.action === DepositAction.MonthPickerSetterValueChangesPostedResp ||
              res.action === DepositAction.MonthPickerSetterValueChangesConciliationResp ||
              res.action ===  DepositAction.MonthPickerSetterValueChangesElectronicResp
            )
          ) {
            this.depositMonthLckBoxCtrl.patchValue(res.data, { emitEvent: false });
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      }),
      this.lockBoxSearch.get('depositdatelockbox')
      .valueChanges.subscribe({
        next: (res) => {
          if (res) {
            this.objServ.behaviorSubjDeposit.next({
              action: DepositAction.MonthPickerSetterValueChangesLockBoxResp,
              data: res
            });
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      }),
      this.$actions.subscribe({
        next: (value) => {
          if (value && value.length) {
            this.actionsDeposit = value;
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      })
    );
  }

  searchOfficeDeposit(req: IDeposit): void {
    this.removeStyleRowGrid();
    if (req.depositdate) {
      let filterModel: any = null, sortModel: any = null;

      if (this.gridLockBoxOptions && this.gridLockBoxOptions.api) {
        filterModel = this.gridLockBoxOptions.api.getFilterModel();
        sortModel = this.gridLockBoxOptions.api.getSortModel();
      }

      this.t2LoadingService.show();
      this.subscriptions.push(
        this.objServ.getOfficeDeposit(req)
        .finally(() => this.t2LoadingService.hiden())
        .subscribe({
          next: (resp) => {
            if (resp && resp.length) {
              this.totalRows = resp.length;

              this.loadGrid(resp);

              this.getTotalLockBoxGrid(DepositGridName.LockBoxGrid, resp);
              if (filterModel) {
                this.gridLockBoxOptions.api.setFilterModel(filterModel);
              }
              if (sortModel) {
                this.gridLockBoxOptions.api.setSortModel(sortModel);
              }
              this.hideActionColumn();
            } else {
              this.clearCountAndGrid();
            }
          },
          error: (er) => this.sweetAlertHelper.captureException(er)
        })
      );
    } else {
      this.clearCountAndGrid();
    }
  }

  getCtrlByName(controlName: string): AbstractControl {
    return this.lockBoxCrudForm.get(controlName);
  }

  setterData(params: any): void {
    if (params && params.data && params.data.officedepositid) {
      const tranDate = CustomDate.formatJs(params.data.trandate, 'yyyy-MM-dd');
      const checkDateI = CustomDate.formatJs(params.data.checkdate, 'yyyy-MM-dd');

      this.getCtrlByName('officedepositid').patchValue(params.data.officedepositid);
      this.getCtrlByName('trandate').patchValue(params.data.trandate);
      this.getCtrlByName('checkaccount').patchValue(params.data.checkaccount);
      this.getCtrlByName('sequence').patchValue(params.data.sequence);
      this.getCtrlByName('serialnumber').patchValue(params.data.serialnumber);
      this.getCtrlByName('amountpaid').patchValue(params.data.amountpaid);
      this.getCtrlByName('statusid').patchValue(params.data.statusid);
      this.getCtrlByName('statusdescription').patchValue(params.data.statusdescription);
      this.getCtrlByName('note').patchValue(params.data.note);
      this.getCtrlByName('posted').patchValue(params.data.posted);
      this.getCtrlByName('payor').patchValue(params.data.payor);
      this.getCtrlByName('reviewedby').patchValue(params.data.reviewedby);
      this.getCtrlByName('reviewedfullname').patchValue(params.data.reviewedfullname);
      this.getCtrlByName('checkdate').patchValue(checkDateI);
      this.getCtrlByName('trandate').patchValue(tranDate);
      this.getCtrlByName('location').patchValue(params.data.location);
    }
  }

  formatCurrency(value: string): string {
    const formatVal = isNaN(Number(value)) ? 0 : Number(value);
    return FormatCurrencyHelper.formatCurrency(formatVal);
  }

  clearControl(controlName: string, value = ''): void {
    this.lockBoxCrudForm.get(controlName).patchValue(value);
  }

  resetForm(): void {
    this.lockBoxCrudForm.reset({
      payor: null
    });
  }

  saveChanges(): void {
    if (this.lockBoxCrudForm.valid) {
      this.t2LoadingService.show();
      const formData = this.lockBoxCrudForm.getRawValue();

      if (formData.officedepositid) {
        const reqUpdate = this.reqNewAndUpdateOfficeDeposit(formData);
        this.subscriptions.push(
          this.objServ.updateOfficeDeposit(reqUpdate)
          .finally(() => this.t2LoadingService.hiden())
          .subscribe({
            next: (resp: any) => {
              if (resp && resp.message) {
                this.objToast.success(resp.message, '', { positionClass: 'toast-bottom-right' });

                if (resp.data) {
                  this.getCtrlByName('reviewedby').patchValue(resp.data.reviewedby);
                  this.getCtrlByName('reviewedfullname').patchValue(resp.data.reviewedfullname);
                  this.getCtrlByName('checkdate').patchValue(resp.data.checkdate);
                  this.updateGridCell(resp.data);
                }
              }
            },
            error: (er) => this.sweetAlertHelper.captureException(er)
          })
        );
      } else {
        const reqNew = this.reqNewAndUpdateOfficeDeposit(formData);
        this.subscriptions.push(
          this.objServ.saveOfficeDeposit(reqNew)
          .finally(() => this.t2LoadingService.hiden())
          .subscribe({
            next: (resp: any) => {
              if (resp && resp.message) {
                this.objToast.success(resp.message, '', { positionClass: 'toast-bottom-right' });
                if (resp.data) {
                  this.run();
                  this.getCtrlByName('officedepositid').patchValue(null);
                }
              }
            },
            error: (er) => this.sweetAlertHelper.captureException(er)
          })
        );
      }
    } else {
      this.objToast.error('Action not allowed', '', { positionClass: 'toast-bottom-right' });
    }
  }

  updateGridCell(data: any) {
    const rowNode = this.gridLockBoxOptions.api.getRowNode(data.officedepositid);
    rowNode.setData(data);
  }

  run(): void {
    if (this.validRunAction()) {
      const dateMonthLockBox = this.depositMonthLckBoxCtrl.value;
      const req: IDeposit = { depositdate: CustomDate.formatJs(dateMonthLockBox, 'MM-yyyy') };
      this.searchOfficeDeposit(req);
    } else {
      this.clearCountAndGrid();
      this.objToast.error('Action not allowed', '', { positionClass: 'toast-bottom-right' });
    }
  }

  clearMonthDate(): void {
    this.depositMonthLckBoxCtrl.patchValue('', { emitEvent: false });
  }

  buildRequest(dataSource: IDeposit): IDeposit {
    let req: IDeposit = null;
    if (dataSource.depositdate) {
      req  = { depositdate: CustomDate.formatJs(dataSource.depositdate, 'MM-yyyy') };
    }
    return req;
  }

  openModalByName(): void {
    this.modalImportLockBox.open();
  }

  selectedFiles(event: any): void {
    if (event && event.target && event.target.files && event.target.files.length) {
      let text = '';
      for (const name of event.target.files) {
        text += name.name + ', ';
      }
      this.lockBoxSearch.patchValue({
        file: text,
        uploadfiles: event.target.files,
      });
    }
  }

  resetImportFile(): void {
    this.fileLockBox.nativeElement.value = '';
    this.lockBoxSearch.patchValue({ file: '', uploadfiles: ''});
  }

  closeModalLockBox(): void {
    this.resetImportFile();
    this.modalImportLockBox.close();
  }

  uploadFile(): void {
    if (this.fileSelected()) {
      this.sweetAlertHelper
      .createCustomAlert({
        title: 'Process File',
        text: 'Are you sure you want to process these deposits files?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, import it!',
        cancelButtonText: 'No, cancel!',
      })
      .then((result) => {
        if (result.value) {
          this.t2LoadingService.show();
          const uploadFiles = this.uploadfilesCtrl.value;
          const params = [{ nameParam: 'dataBodySpreadSheet', data: { extension: 'xls' } }];
          this.subscriptions.push(
            this.uploadsService
            .makeFileRequest(`${constant.URL_API_DEPOSIT_UPLOAD_FILE}?optionImport=${this.optionImportLockBox}`,
              params, uploadFiles, 'file')
            .finally(() => this.t2LoadingService.hiden())
            .subscribe({
              next: (resp) => {
                if (resp && (resp.totalinserted || resp.totalduplicates || resp.totaltoinsert)) {
                  this.sweetAlertHelper.createCustomAlert({
                    title: 'Import File',
                    text: `Lock Box Import Success`,
                    type: 'success',
                    html: `<div>Total Inserted: ${resp.totalinserted ? resp.totalinserted : 0 }</div>
                          <div>Total Duplicates: ${resp.totalduplicates ? resp.totalduplicates : 0}</div>
                          <div>Total: ${resp.totaltoinsert ? resp.totaltoinsert : 0}</div>`
                  }).then(() => {
                    this.t2LoadingService.hiden();
                    this.closeModalLockBox();
                  });
                }
              },
              error: (er) => {
                this.sweetAlertHelper.captureException(er)
                .then(() => this.closeModalLockBox());
              }
            })
          );
        }
      });
    } else {
      this.objToast.error('Action not allowed', '', { positionClass: 'toast-bottom-right' });
      this.closeModalLockBox();
    }
  }

  getTotalLockBoxGrid(objTable: string, dataSource: any[]): void {
    switch (objTable) {
      case DepositGridName.LockBoxGrid:
        if (dataSource && dataSource.length) {
          this.totalAmount = dataSource.reduce((sum, item) => sum + item.amountpaid, 0);
          this.totalLockBoxAmountSelected = dataSource.reduce((sum, item) => sum + item.amountpaid, 0);
        }
        break;
      default:
        break;
    }
  }

  clearFilterAndSort(nameBtn: AgButtonsEnum): void {
    switch (nameBtn) {
      case AgButtonsEnum.RemoveFilter:
        this.totalLockBoxAmountSelected = this.totalAmount;
        this.gridLockBoxOptions.api.setFilterModel(null);
        break;
      case AgButtonsEnum.RemoveSort:
        this.gridLockBoxOptions.api.setSortModel(null);
        break;
      default:
        break;
    }
    this.updateButtonState();
  }

  fileSelected(): boolean {
    return this.filesNamesCtrl.value !== '';
  }

  updateButtonState(): void {
    const filterApply = !Object.keys(this.gridLockBoxOptions.api.getFilterModel()).length;
    this.enableClearFilter = filterApply;
    this.enableClearSort = !this.gridLockBoxOptions.api.getSortModel().length;

    if (!filterApply) {
      this.sumTotalLockBoxSelected();
    }
  }

  sumTotalLockBoxSelected(): void {
    let total = 0;
    this.gridLockBoxOptions.api.forEachNodeAfterFilterAndSort((node) => {
      if (node && node.data && node.data.amountpaid) {
        total += node.data.amountpaid;
      }
    });
    this.totalLockBoxAmountSelected = total;
  }

  formatCurrencyText(valueFormated): string {
    const formatVal = isNaN(Number(valueFormated)) ? 0 : Number(valueFormated);
    return FormatCurrencyHelper.formatCurrency(formatVal);
  }

  validRunAction(): boolean {
    const depositdate = this.depositMonthLckBoxCtrl.value;
    return depositdate;
  }

  clearCountAndGrid(): void {
    this.totalLockBoxAmountSelected = 0;
    this.totalRows = 0;
    if (this.gridLockBoxOptions && this.gridLockBoxOptions.api) {
      this.gridLockBoxOptions.api.setRowData([]);
    }
  }

  execSpUpdateOfficeDeposit(): void {
    if (!this.actionsDeposit.includes(DepositActions.PostedUpdateLockBoxStatus)) {
      this
        .objToast
        .error(
          'You do not have permission to perform this action',
          'Access Denied!',
          {positionClass: 'toast-bottom-right'});

      return;
    }

    this.t2LoadingService.show();
    this.subscriptions.push(
      this.objServ.updateOfficeDepositStatus(this.depositMonthLckBoxCtrl.value)
        .finally(() => this.t2LoadingService.hiden())
        .subscribe({
          next: (res): void => {
            if (res && res.message) {
              this.objToast.success(res.message, 'Office Deposit Status', {positionClass: 'toast-bottom-right'});
              this.run();
            }
          },
          error: (err) => this.sweetAlertHelper.captureException(err)
        })
    );
  }

  openModalOfficeDeposit(actionName: string): void {
    if (actionName === 'New') {
      this.officeModalTitle = `New Office Deposit`;
      this.buttonModalText = 'Save';
      this.saveOffice = true;
      this.resetCrudModal();
    } else {
      const amount = this.amountpaidVal ? this.amountpaidVal.toString() : '0';
      this.officeModalTitle = `Sequence #${this.officeDepositIdCtrl.value} - ${this.formatCurrency(amount)}`;
      this.buttonModalText = 'Update';
      this.saveOffice = false;
    }
  }

  clearRecords(): void {
    while (this.officeDeposiFormtArrayCtrl.controls.length !== 0) {
      this.officeDeposiFormtArrayCtrl.removeAt(0);
    }
  }

  setFormArray(details: any[]): void {
    this.clearRecords();
    details.forEach(detail => {
      const groupIterate = this.createFormGroup(detail);
      this.officeDeposiFormtArrayCtrl.push(groupIterate);
    });
  }

  createFormGroup(rowValue: any): FormGroup {
    const checkdate = rowValue && rowValue.checkdate ? CustomDate.formatJs(rowValue.checkdate, 'yyyy-MM-dd') : null;
    const trandate = rowValue && rowValue.trandate ? CustomDate.formatJs(rowValue.trandate, 'yyyy-MM-dd') : null;

    const group = this.fb.group({
      keygenerated: rowValue.officedepositid ? DepositAction.Update : DepositAction.Save,
      trandate: trandate,
      amountpaid: [rowValue.amountpaid, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      checkdate: [checkdate, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      location: rowValue.location,
      note: rowValue.note,
      officedepositid: rowValue.officedepositid,
      payor: [rowValue.payor, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      posted: [rowValue.posted, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      reviewedby: rowValue.reviewedby,
      reviewedfullname: rowValue.reviewedfullname,
      sequence: rowValue.sequence,
      serialnumber: [rowValue.serialnumber, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      statusdescription: rowValue.statusdescription,
      statusid: rowValue.statusid,
      deposit: rowValue.deposit ? rowValue.deposit : 0,
      depositid: rowValue.depositid
    });
    return group;
  }

  openModalOfficeDepositSelected(actionName: string): void {
    if (actionName === DepositAction.Save) {
      this.diffBetweenDepositAmtAndAmtPaid = null;
      this.textBtnModalOfficeDepositCrud = DepositAction.Save;
      this.textModalCrud = 'New Office Deposit';
      this.clearRecords();
      this.ClearAndCloseOffDep();
      this.modalOfficeDepositSelected.open();
    }
  }

  resetCrudModal(): void {
    this.lockBoxCrudForm.patchValue({
      officedepositid: null,
      trandate: null,
      checkdate: null,
      checkaccount: null,
      sequence: null,
      serialnumber: null,
      amountpaid: null,
      payor: null,
      posted: null,
      note: '',
      statusid: 1,
      statusdescription: 'Pending',
      reviewedby: null,
      reviewedfullname: null,
      depositid: null
    });
  }

  reqNewAndUpdateOfficeDeposit(formData: ILockBox): ILockBox {
    return {
      serialnumber: formData.serialnumber,
      posted: formData.posted,
      payor: formData.payor,
      note: formData.note ? formData.note : '',
      checkdate: formData.checkdate,
      officedepositid: formData.officedepositid,
      amountpaid: formData.amountpaid,
      trandate: formData.trandate,
      location: formData.location,
    };
  }

  deleteRow(event: any): void {
    if (this.actionsDeposit.includes(DepositActions.OfficeDepositDelete)) {
      if (event && event.colDef && event.colDef.colId === 'action') {
        if (event.data && event.data.officedepositid) {
          this.sweetAlertHelper.createCustomAlert(
            {
              title: 'Confirm',
              text: 'Are you sure you want to delete this record?',
              type: 'warning',
              showCloseButton: true,
              showCancelButton: true,
              cancelButtonColor: '#dc3545',
              confirmButtonColor: '#1464f6'
            }
          )
          .then((resModal: any) => {
            if (resModal && resModal.value) {
              this.t2LoadingService.show();
              this.subscriptions.push(
                this.deleteOffDepositbyIdObs(event.data.officedepositid)
                .finally(() => this.t2LoadingService.hiden())
                .subscribe({
                  next: (res) => {
                    if (res && res.message) {
                      this.gridLockBoxOptions.api.removeItems([event.node]);
                      this.objToast.success(res.message, 'Success!', { positionClass: 'toast-bottom-right' });
                    }
                  },
                  error: (err) => this.sweetAlertHelper.captureException(err)
                })
              );
            }
          });
        }
      }
    } else {
      this.objToast.error('You do not have permission to perform this action', 'Access Denied!',
        { positionClass: 'toast-bottom-right' });
    }
  }

  hideActionColumn(): void {
    if (this.gridLockBoxOptions && this.gridLockBoxOptions.api) {
      const depositDeleteAction = this.actionsDeposit.includes(DepositActions.OfficeDepositDelete);
      this.gridLockBoxOptions.columnApi.setColumnVisible('action', depositDeleteAction);
    }
  }

  onMultiSelectionChanged(param: SelectionChangedEvent): void {
    if (param && this.gridLockBoxOptions && this.gridLockBoxOptions.api) {
      this.officeDepositRowSelected = getSelectNodeAfterFilter(this.gridLockBoxOptions);
    } else {
      this.officeDepositRowSelected = [];
    }
  }

  getCtrlOffiDepModal(controlName: string): AbstractControl {
    return this.officeDeposiModalGroup.get(controlName);
  }

  addRow(): void {
    const location = this.getCtrlOffiDepModal('scanneddoc').value;
    const receivedin = this.getCtrlOffiDepModal('receivedin').value;
    const deposit = this.getCtrlOffiDepModal('deposit').value;

    const newGroup = this.fb.group({
      keygenerated: DepositAction.Save,
      trandate: receivedin,
      amountpaid: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      checkdate: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      location: location,
      note: null,
      officedepositid: null,
      payor: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      posted: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      reviewedby: null,
      reviewedfullname: null,
      sequence: null,
      serialnumber: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      statusdescription: 'Pending',
      statusid: 1,
      deposit: deposit,
      depositid: null
    });
    this.officeDeposiFormtArrayCtrl.insert(0, newGroup);
  }

  saveOfficeDeposit(): void {
    this.t2LoadingService.show();
    const listForm: any[] = this.officeDeposiFormtArrayCtrl.getRawValue();
    if (listForm && listForm.length && !this.validButtonSaveModalOffDep) {
      const requests = [];
      const location = this.getCtrlOffiDepModal('scanneddoc').value;
      const receivedin = this.getCtrlOffiDepModal('receivedin').value;
      const deposit = this.getCtrlOffiDepModal('deposit').value;
      const depVal = deposit ? Number(deposit) : 0;
      const depositId = this.depositOfficeDescriptionSelected ? this.depositOfficeDescriptionSelected : null;

      listForm.forEach(row => {
        row.trandate = receivedin;
        row.location = location;
        row.deposit = depVal;
        row.depositid = depositId;
      });

      const saveList = listForm.filter(rowToInsert => rowToInsert.keygenerated === DepositAction.Save);
      const updateList = listForm.filter(rowToInsert => rowToInsert.keygenerated === DepositAction.Update);

      if (saveList && saveList.length) {
        requests.push(this.objServ.saveMasiveOfficeDeposit(saveList));
      }

      if (updateList && updateList.length) {
        requests.push(this.objServ.updateMasiveOfficeDeposit(updateList));
      }

      if (requests.length) {
        this.subscriptions.push(
          forkJoin(requests)
          .finally(() => this.t2LoadingService.hiden())
            .subscribe({
            next: (res: any) => {
              this.objToast.success(res.message,
                `Saved Changes`,
                { positionClass: 'toast-bottom-right', timeOut: 8000 }
              );
              this.run();
              this.closeModalOffDepCrud();
              this.clearRecords();
              this.depositOfficeDescriptionSelected = null;
            },
            error: (er) => {
              this.depositOfficeDescriptionSelected = null;
              this.sweetAlertHelper.captureException(er);
            }
          })
        );
      }
    } else {
      this.t2LoadingService.hiden();
      this.clearRecords();
      this.ClearAndCloseOffDep();
      this.depositOfficeDescriptionSelected = null;
      this.objToast.error('Action not allowed', '', { positionClass: 'toast-bottom-right' });
    }
  }

  deleteRowOffDepModal(i: number, item: any): void {
    if (item && item.value && item.value.officedepositid) {

      this.sweetAlertHelper.createCustomAlert(
        {
          title: 'Confirm',
          text: 'Are you sure you want to delete this record?',
          type: 'warning',
          showCloseButton: true,
          showCancelButton: true,
          cancelButtonColor: '#dc3545',
          confirmButtonColor: '#1464f6'
        }
      )
      .then((resModal: any) => {
        if (resModal && resModal.value) {
          this.officeDeposiFormtArrayCtrl.removeAt(i);
          this.t2LoadingService.show();
          this.subscriptions.push(
            this.deleteOffDepositbyIdObs(item.value.officedepositid)
            .finally(() => this.t2LoadingService.hiden())
            .subscribe({
              next: (res) => {
                if (res && res.message) {
                  this.objToast.success(res.message, 'Success!', { positionClass: 'toast-bottom-right' });
                  this.run();
                  this.diffCount();
                }
              },
            })
          );
        }
      });

    } else {
      this.officeDeposiFormtArrayCtrl.removeAt(i);
      this.diffCount();
    }
  }

  searchOfficeDepositGrouped(rowData: any): void {
    this.t2LoadingService.show();
    this.subscriptions.push(
      this.objServ.getOfficeDepositGrouped(rowData)
      .finally(() => this.t2LoadingService.hiden())
      .subscribe({
        next: (resp) => {
          if (resp && resp.length) {
            this.rowIdGrouped = resp.map((rowFilter: any) => rowFilter.officedepositid);
            this.setFormArray(resp);
            const firstRow = resp.find(() => true);

            if (firstRow) {
              const tranDate = CustomDate.formatJsV2(firstRow.trandate);
              this.getCtrlOffiDepModal('receivedin').patchValue(tranDate);
              this.getCtrlOffiDepModal('scanneddoc').patchValue(firstRow.location);
              this.getCtrlOffiDepModal('deposit').patchValue(firstRow.deposit);
              this.textBtnModalOfficeDepositCrud = DepositAction.Update;
              this.modalOfficeDepositSelected.open();
              this.diffCount();
            }
            this.gridLockBoxOptions.api.redrawRows();
          } else {
            this.objToast.error('No result Found', 'Search Office Deposit Grouped',
              { positionClass: 'toast-bottom-right' });
              this.ClearAndCloseOffDep();
          }
        },
        error: (er) => {
          this.ClearAndCloseOffDep();
          this.sweetAlertHelper.captureException(er);
        }
      })
    );
  }

  clearDataModal(): void {
    this.sweetAlertHelper
    .createCustomAlert({
      title: 'Office Deposit',
      text: 'Are you sure you want to cancel the operation?',
      type: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, cancel',
      cancelButtonText: 'No',
      focusCancel: true
    }).then((result) => {
      if (result.value) {
        this.closeModalOffDepCrud();
      }
    });
  }

  closeModalOffDepCrud(): void {
    this.depositOfficeDescriptionList = [];
    this.depositOfficeDescriptionSelected = null;
    this.modalOfficeDepositSelected.close();
  }

  ClearAndCloseOffDep(): void {
    this.getCtrlOffiDepModal('receivedin').patchValue(null);
    this.getCtrlOffiDepModal('scanneddoc').patchValue(null);
    this.getCtrlOffiDepModal('deposit').patchValue(null);
    this.closeModalOffDepCrud();
  }

  deleteOffDepositbyIdObs(officedepositid: number): Observable<any> {
    return this.objServ.deleteOfficeDeposit(officedepositid);
  }

  removeStyleRowGrid(): void {
    this.rowIdGrouped = [];
  }

  diffCount(arrayListParam?: any[]): void {
    const arrayList = arrayListParam && arrayListParam.length ? arrayListParam : this.officeDeposiFormtArrayCtrl.getRawValue();
    let countAmountPaid = 0;

    if (arrayList.length) {
      arrayList.forEach(row => {
        countAmountPaid += isNaN(Number(row.amountpaid)) ? 0 : Number(row.amountpaid);
      });
    }

    const substractVal = (this.getCtrlOffiDepModal('deposit').value - Number(countAmountPaid.toFixed(2)));
    this.diffBetweenDepositAmtAndAmtPaid = substractVal;
  }

  getGroupCount(): void {
    let groupCount = 0;

    if (this.gridLockBoxOptions && this.gridLockBoxOptions.api) {
      const totalRows = this.gridLockBoxOptions.api.getDisplayedRowCount();
      for (let i = 0; i < totalRows; i++) {
        const rowNode = this.gridLockBoxOptions.api.getDisplayedRowAtIndex(i);
        if (rowNode.group) {
          groupCount++;
        }
      }
    }

    this.displayedGroupCount = groupCount;
  }

  loadGrid(data) {
    const rowSpanList = this.rowSpan(data);
    this.gridLockBoxOptions.api.setRowData(rowSpanList);
  }

  rowSpan(data: any []): any {
    data.map((item: any, index: any) => {
      if (index === data.findIndex((elem: any) => elem.groupkey === item.groupkey)) {
        item.rowSpan = data.filter((value: any) => value.groupkey === item.groupkey).length;
      }
      return item;
    });

    return data;
  }

  getOfficeDepositDescriptionList(trandate: any): void {
    this.depositOfficeDescriptionList = [];
    if (trandate) {
      this.t2LoadingService.show();
      this.subscriptions.push(
        this.objServ.getOfficeDepositDescriptionList(trandate)
        .finally(() => this.t2LoadingService.hiden())
        .subscribe({
          next: (res) => {
            if (res && res.length) {
              this.depositOfficeDescriptionList = res;
            } else {
              this.depositOfficeDescriptionSelected = null;
            }
          },
          error: (er) => {
            this.depositOfficeDescriptionSelected = null;
            this.sweetAlertHelper.captureException(er);
          }
        })
      );
    } else {
      this.objToast.error('Action not allowed', 'Office Deposit Description List',
        { positionClass: 'toast-bottom-right' });
    }
  }

  receivedInChange(): void {
    const transVal = this.getCtrlOffiDepModal('receivedin').value;
    if (transVal) {
      this.getOfficeDepositDescriptionList(transVal);
    } else {
      this.depositOfficeDescriptionList = [];
    }
  }

  confirmCloseModal(event: any): void {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) =>
      subscription.unsubscribe()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/deposits/office-deposit/office-deposit.component.ts